import {useHistory} from 'react-router-dom';

const PAGES_ROUTE = '/pages';

/**
 * A "Back" handler for pages reachable from more than one place (the app
 * itself, or a public marketing link): goes back in history when the
 * previous entry is inside this app, otherwise lands on My pages rather
 * than leaving the app entirely.
 */
const useSmartBack = (fallbackRoute = PAGES_ROUTE) => {
    const history = useHistory();

    return () => {
        const cameFromThisApp = document.referrer && document.referrer.startsWith(window.location.origin);
        if (cameFromThisApp && history.length > 1) {
            history.goBack();
        } else {
            history.push(fallbackRoute);
        }
    };
};

export default useSmartBack;
